import * as React from "react";
import { useState } from "react";
import { useModal } from "../../core/hooks/useModal";
import { Button } from "./Button";
import type { ButtonVariant } from "./Button";

interface IConfirmModalData {
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: ButtonVariant;
  onConfirm?: () => Promise<void> | void;
}

export function ConfirmModal() {
  const modal = useModal();
  const modalData = (modal.modalData as IConfirmModalData) || {};

  const [processing, setProcessing] = useState(false);

  const titleText = modalData.title || "Confirm Action";
  const messageText = modalData.message || "Are you sure you want to proceed?";
  const confirmLabelText = modalData.confirmLabel || "Confirm";
  const cancelLabelText = modalData.cancelLabel || "Cancel";
  const btnVariant = modalData.variant || "primary";
  const confirmFn = modalData.onConfirm;

  const handleConfirm = async () => {
    setProcessing(true);
    try {
      if (confirmFn) {
        await confirmFn();
      }
      modal.modalRef?.close(true);
    } catch (error) {
      console.error("Modal confirmation error:", error);
    } finally {
      setProcessing(false);
    }
  };

  const handleCancel = () => {
    modal.modalRef?.dismiss();
  };

  return (
    <div className="flex flex-col p-6 max-w-sm">
      <div className="flex items-center mb-4">
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center mr-3 ${
            btnVariant === "danger"
              ? "bg-danger-10 text-danger"
              : btnVariant === "warning"
              ? "bg-warning-10 text-warning"
              : "bg-primary-10 text-primary"
          }`}
        >
          <i
            className={`${
              btnVariant === "danger"
                ? "ri-error-warning-line"
                : btnVariant === "warning"
                ? "ri-alert-line"
                : "ri-question-line"
            } text-xl`}
          ></i>
        </div>
        <h3 className="text-xl font-bold text-text">{titleText}</h3>
      </div>

      <p className="text-text-light mb-8 leading-relaxed">{messageText}</p>

      <div className="flex justify-end space-x-3">
        <Button
          onClick={handleCancel}
          variant="ghost"
          disabled={processing}
        >
          {cancelLabelText}
        </Button>
        <Button
          onClick={handleConfirm}
          variant={btnVariant}
          loading={processing}
          disabled={processing}
        >
          {confirmLabelText}
        </Button>
      </div>
    </div>
  );
}
